import React, { useState } from 'react';
import { Snackbar, Alert, AlertColor } from '@mui/material';

export const SnackbarLayout: React.FC<{
    message: string;
    variant: AlertColor;
    duration?: number;
    onDismiss: (id: number) => void;
    id: number;
}> = (props) => {
    const [open, setOpen] = useState(true);

    const handleDismiss = () => {
        setOpen(false);
        props.onDismiss(props.id);
    };

    return (
        open && (
            <Snackbar open={open} autoHideDuration={3000} onClose={handleDismiss} anchorOrigin={{vertical: 'top', horizontal: 'left' }} sx={{ width: '99%' }}>
                <Alert onClose={handleDismiss} severity={props.variant} sx={{ width: '100%' }}>
                    {props.message}
                </Alert>
            </Snackbar>
        )
    );
};
